<div class="row">
  <div class="col-12">
  <!-- <div [ngClass]="{'col-8':showStatusBox, 'col-12':!showStatusBox}"> -->
          <div class="collapsable-container">
          <div class="collapsable-container-header" (click)="collapsed = !collapsed">
              <div class="heading">
                  <span class="btn-collapse"><span class="fa fa-fw fa-angle-double-down"></span></span>
                  <span class="fa fa-filter"></span> Filter: {{ FilterDescription }}
              </div>
          </div>
          <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsed}">
              <div class="row mt-3 ml-1">
                  <div class="col-12">
                      <form [formGroup]="filterFormGroup" class="">
                          <div class="row">
                              <div class="col-lg-4">
                                  <div class="form-group row">
                                      <div class="col-lg-12">
                                          <yt-dropdown-picklist [ModelName]="'komitent'" [GetName]="'get'"
                                              [ModelProperty]="'SNaziv,Mesto'" [OrderBy]="'SNaziv'"
                                              [AllowAddNew]="false" formControlName="KomitentID"
                                              [Label]="'FAKDOKUMENT.KOMITENT.SINGULAR'" [Required]="false"
                                              (OnItemSelected)="SelectKomitent($event)">
                                          </yt-dropdown-picklist>
                                      </div>
                                  </div>
                              </div>
                              <div class="mr-2">
                                  <button
                                   type="button"
                                   (click)="ApplyFilter()"
                                   class="btn btn-secondary"
                                   ngbTooltip="{{'FILTER.APPLYFILTER.TOOLTIP' | translate }}"
                                  >
                                      <span class="fa fa-search"></span>
                                  </button>
                              </div>
                              <div class="mr-2">
                                  <button type="button" (click)="ResetFilter()" class="btn btn-secondary"
                                      ngbTooltip="{{'FILTER.RESETFILTER.TOOLTIP' | translate }}">
                                      <span class="fa fa-undo"></span>
                                  </button>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>